import VideoConferencing from "./VideoConferencingContainer";

export default VideoConferencing;
